<template>
    <div>
        <h2>Appointment Management</h2>
        <hr />
        <div class="d-flex justify-content-between mb-3">
            <div>
                <button v-if="selectedAppointment" class="btn btn-warning btn-sm me-2"
                    @click="editAppointment(selectedAppointment.id)">Edit</button>
                <button v-if="selectedAppointment" class="btn btn-danger btn-sm"
                    @click="toggleAppointment(selectedAppointment.id)">
                    {{ selectedAppointment.status === 'cancelled' ? 'Enable' : 'Cancel' }}
                </button>
            </div>
            <button class="btn btn-primary btn-sm" @click="createAppointment">Add Appointment</button>
        </div>
        <div class="mb-3 d-flex align-items-center">
            <label class="me-2 mb-0">Filter by Date:</label>
            <input type="date" v-model="filterDate" @change="fetchAppointments" class="form-control form-control-sm"
                style="max-width: 200px;" />
        </div>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Student</th>
                        <th>Counselor</th>
                        <th>Date</th>
                        <th>Time Slot</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(appointment, index) in appointments" :key="appointment.id"
                        :class="{ 'bg-disabled': appointment.status === 'cancelled', 'table-active': selectedAppointment && selectedAppointment.id === appointment.id }"
                        @click="selectAppointment(appointment)">
                        <td>{{ index + 1 }}</td>
                        <td>{{ appointment.student?.user?.name }}</td>
                        <td>{{ appointment.counselor?.user?.name }}</td>
                        <td>{{ $formatDate(appointment.appointment_date) }}</td>
                        <td>{{ $convertTo12Hour(appointment.timeslot?.start_time) }} -
                            {{ $convertTo12Hour(appointment.timeslot?.end_time) }}</td>
                        <td>
                            <span :class="{
                                'text-success': appointment.status === 'scheduled',
                                'text-danger': appointment.status === 'cancelled',
                                'text-warning': appointment.status === 'rescheduled',
                                'text-muted': appointment.status === 'completed'
                            }">
                                {{ appointment.status }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            appointments: [],
            selectedAppointment: null,
            filterDate: new Date().toISOString().split("T")[0], // default: today
        };
    },
    methods: {
        fetchAppointments() {
            this.$api.get('/appointments', {
                params: {
                    date: this.filterDate
                }
            }).then(response => {
                this.appointments = response.data;
            });
        },
        createAppointment() {
            this.$router.push('/dashboard/appointments/create');
        },
        editAppointment(id) {
            this.$router.push(`/dashboard/appointments/edit/${id}`);
        },
        toggleAppointment(id) {
            this.$api.post(`/appointments/${id}/toggle`).then(() => {
                this.fetchAppointments();
                this.selectedAppointment = null;
            });
        },
        selectAppointment(appointment) {
            this.selectedAppointment = this.selectedAppointment && this.selectedAppointment.id === appointment.id ? null : appointment;
        }
    },
    mounted() {
        this.fetchAppointments();
    }
};
</script>

<style>
.bg-disabled {
    background-color: #f8d7da !important;
    color: #721c24 !important;
}

.table-active {
    background-color: #d1ecf1 !important;
}

.bg-disabled td {
    background-color: #f8d7da !important;
}
</style>
